interface Props {
  children?: React.ReactNode;
  className?: string;
  label: string;
}

export function Item(props: Props) {
  return (
    <div className={props.className}>
      <div className="mb-2 text-xs text-neutral-400">{props.label}</div>
      <div className="text-white text-sm">{props.children}</div>
    </div>
  );
}
